import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import apiConfig from "../config/apiConfig";

function MotivationalTips() {
  const serverUrl = apiConfig.serverUrl;
  const [tips, setTips] = useState([]);
  const [modal, setModal] = useState(false);
  const [editTip, setEditTip] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [formData, setFormData] = useState({
    text: "",
    video_url: "",
    publish_date: "",
    expiration_date: "",
    diet_type: []
  });
  const [previewModal, setPreviewModal] = useState(false);
  const [previewVideoUrl, setPreviewVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("motivational");

  // تبدیل لینک یوتیوب به فرمت embed
  const convertToEmbedUrl = (url) => {
    if (!url) return "";
    const pattern = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(pattern);
    return match ? `https://www.youtube.com/embed/${match[1]}` : url;
  };
  // تابع بررسی تداخل تاریخ‌ها
const checkDateOverlap = (newTip, existingTips, dietType, tipType) => {
  const newStart = new Date(newTip.publish_date);
  const newEnd = new Date(newTip.expiration_date);

  for (const tip of existingTips) {
    if (tip.type === tipType && (tip.diet_type === dietType || tip.diet_type === "all" || dietType === "all")) {
      const existingStart = new Date(tip.publish_at);
      const existingEnd = new Date(tip.expires_at);

      // بررسی تداخل: اگر تاریخ شروع یا پایان جدید در بازه تاریخ‌های موجود باشد
      if (
        (newStart >= existingStart && newStart <= existingEnd) ||
        (newEnd >= existingStart && newEnd <= existingEnd) ||
        (newStart <= existingStart && newEnd >= existingEnd)
      ) {
        return {
          hasOverlap: true,
          existingTip: tip
        };
      }
    }
  }
  return { hasOverlap: false };
};

  // دریافت نکات از API
  const fetchTips = async () => {
    try {
      const response = await axios.get(`${serverUrl}motivational-tips`);
      setTips(response.data);
      setLoading(false);
    } catch (error) {
      toast.error("خطا در دریافت نکات");
      setLoading(false);
    }
  };

  // بارگذاری اولیه و تایمر دوره‌ای برای به‌روزرسانی
  useEffect(() => {
    fetchTips();
    const interval = setInterval(fetchTips, 60000);
    return () => clearInterval(interval);
  }, [serverUrl]);

  const toggleModal = (type = null, isEdit = false, tip = null) => {
    setModal(!modal);
    setCurrentType(type);
    if (!isEdit) {
      setEditTip(null);
      setFormData({
        text: "",
        video_url: "",
        publish_date: "",
        expiration_date: "",
        diet_type: []
      });
    } else {
      setEditTip(tip);
      setFormData({
        text: tip.text || "",
        video_url: tip.video_url || "",
        publish_date: tip.publish_at ? tip.publish_at.split('T')[0] : "",
        expiration_date: tip.expires_at ? tip.expires_at.split('T')[0] : "",
        diet_type: Array.isArray(tip.diet_type) ? tip.diet_type : [tip.diet_type]
      });
    }
  };

  const togglePreviewModal = (videoUrl = "") => {
    const embedUrl = convertToEmbedUrl(videoUrl);
    setPreviewVideoUrl(embedUrl);
    setPreviewModal(!previewModal);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: name === "video_url" ? convertToEmbedUrl(value) : value });
  };

  const handleDietTypeChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, option => option.value);
    setFormData({ ...formData, diet_type: selected.includes("all") ? ["all"] : selected });
  };

  const handleQuillChange = (value) => {
    setFormData({ ...formData, text: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if ((!formData.text && currentType !== "video") || !formData.publish_date || !formData.expiration_date || formData.diet_type.length === 0) {
      toast.error("لطفاً تمام فیلدها را پر کنید.");
      return;
    }
    if (currentType === "video" && !formData.video_url) {
      toast.error("لینک ویدئو الزامی است.");
      return;
    }
  
    try {
      if (editTip) {
        // برای ویرایش، بررسی تداخل با سایر نکات (به جز خود نکته در حال ویرایش)
        const overlapCheck = checkDateOverlap(
          formData,
          tips.filter(tip => tip.id !== editTip.id),
          formData.diet_type[0],
          currentType
        );
        if (overlapCheck.hasOverlap) {
          toast.error(
            `تداخل تاریخ با نکته موجود: از ${overlapCheck.existingTip.publish_at.split('T')[0]} تا ${overlapCheck.existingTip.expires_at.split('T')[0]}`
          );
          return;
        }
  
        const payload = {
          ...formData,
          type: currentType,
          publish_at: formData.publish_date,
          expires_at: formData.expiration_date,
          diet_type: formData.diet_type[0]
        };
  
        const response = await axios.put(`${serverUrl}motivational-tips/${editTip.id}`, payload);
        setTips(tips.map(tip => (tip.id === editTip.id ? response.data : tip)));
        toast.success("نکته با موفقیت ویرایش شد.");
      } else {
        let dietTypes = formData.diet_type;
        if (dietTypes.includes("all")) {
          dietTypes = ["decrease", "increase", "stability"];
        }
  
        // بررسی تداخل برای هر نوع رژیم
        for (const dietType of dietTypes) {
          const overlapCheck = checkDateOverlap(formData, tips, dietType, currentType);
          if (overlapCheck.hasOverlap) {
            toast.error(
              `تداخل تاریخ برای رژیم ${getDietTypeLabel(dietType)}: از ${overlapCheck.existingTip.publish_at.split('T')[0]} تا ${overlapCheck.existingTip.expires_at.split('T')[0]}`
            );
            return;
          }
        }
  
        const createdTips = [];
        for (const dietType of dietTypes) {
          const payload = {
            ...formData,
            type: currentType,
            publish_at: formData.publish_date,
            expires_at: formData.expiration_date,
            diet_type: dietType
          };
  
          const response = await axios.post(`${serverUrl}motivational-tips`, payload);
          createdTips.push(response.data);
        }
        setTips([...tips, ...createdTips]);
        toast.success("نکته با موفقیت اضافه شد.");
      }
  
      await fetchTips();
      setFormData({ text: "", video_url: "", publish_date: "", expiration_date: "", diet_type: [] });
      setEditTip(null);
      toggleModal();
    } catch (error) {
      const errorMsg = error.response?.data?.errors?.video_url
        ? "لینک ویدئوی یوتیوب نامعتبر است یا اجازه جاسازی ندارد."
        : error.response?.data?.errors || error.message;
      toast.error("خطا در ذخیره نکته: " + JSON.stringify(errorMsg));
    }
  };

  const handleEdit = (type, tip) => {
    toggleModal(type, true, tip);
  };

  const handleDelete = async (id, type) => {
    Swal.fire({
      title: "آیا مطمئن هستید؟",
      text: "این نکته حذف خواهد شد!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "بله، حذف کن",
      cancelButtonText: "خیر"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${serverUrl}motivational-tips/${id}?type=${type}`);
          await fetchTips();
          toast.success("نکته با موفقیت حذف شد.");
        } catch (error) {
          toast.error("خطا در حذف نکته: " + (error.response?.data?.message || error.message));
        }
      }
    });
  };

  const getDietTypeLabel = (dietTypes) => {
    if (!Array.isArray(dietTypes)) dietTypes = [dietTypes];
    return dietTypes.map(type => {
      switch (type) {
        case "decrease": return "کاهش وزن";
        case "increase": return "افزایش وزن";
        case "stability": return "ثبات وزن";
        case "all": return "همه";
        default: return type;
      }
    }).join(", ");
  };

  const filterTipsByType = (type) => tips.filter(tip => tip.type === type);

  const filterTipsByDiet = (tipsList, diet) => {
    return tipsList.filter(tip => tip.diet_type === diet || tip.diet_type === "all");
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // تابع نمایش وضعیت - فقط status را از بک‌اند نمایش می‌دهد
  const getStatusDisplay = (tip) => {
    // وضعیت از بک‌اند محاسبه و ذخیره می‌شود، فقط نمایش می‌دهیم
    return tip.status === "active" ? "فعال" : "غیرفعال";
  };

  const renderTipsTable = (tipType, diet) => {
    let filteredTips = filterTipsByDiet(filterTipsByType(tipType), diet);
    const isVideo = tipType === "video";

    // Remove duplicates based on content
    const seen = new Set();
    filteredTips = filteredTips.filter(tip => {
      const key = isVideo ? tip.video_url : tip.text;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    return (
      <div className="bg-white rounded-xl shadow-lg p-4 transition-all duration-300 hover:shadow-xl">
        <Table responsive className="modern-table">
          <thead>
            <tr>
              <th className="text-black">{isVideo ? "ویدئو" : "متن"}</th>
              <th className="text-black">تاریخ انتشار</th>
              <th className="text-black">تاریخ انقضا</th>
              <th className="text-black">وضعیت</th>
              <th className="text-black">عملیات</th>
            </tr>
          </thead>
          <tbody>
            {filteredTips.map(tip => (
              <tr key={tip.id} className="hover:bg-gray-50 transition-colors duration-200">
                <td className="text-black">
                  {isVideo ? (
                    tip.video_url ? (
                      <Button
                        color="info"
                        size="sm"
                        className="px-3 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                        onClick={() => togglePreviewModal(tip.video_url)}
                      >
                        پیش‌نمایش
                      </Button>
                    ) : "بدون ویدئو"
                  ) : (
                    <div className="text-black" dangerouslySetInnerHTML={{ __html: tip.text }} />
                  )}
                </td>
                <td className="text-black">{tip.publish_at ? tip.publish_at.split('T')[0] : '-'}</td>
                <td className="text-black">{tip.expires_at ? tip.expires_at.split('T')[0] : '-'}</td>
                <td className="text-black">{getStatusDisplay(tip)}</td>
                <td>
                  <Button 
                    color="warning" 
                    size="sm" 
                    className="px-3 py-1 rounded-lg mr-2 hover:bg-yellow-500 transition-colors"
                    onClick={() => handleEdit(tipType, tip)}
                  >
                    ویرایش
                  </Button>
                  <Button 
                    color="danger" 
                    size="sm" 
                    className="px-3 py-1 rounded-lg hover:bg-red-600 transition-colors"
                    onClick={() => handleDelete(tip.id, tipType)}
                  >
                    حذف
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="content" style={{ direction: "rtl", textAlign: "right" }}>
        <Row>
          <Col md="12">
            <Card className="modern-card bg-gradient-to-br from-white to-gray-50">
              <CardHeader className="bg-blue-900">
                <CardTitle tag="h4" className="text-white">مدیریت نکات انگیزشی</CardTitle>
              </CardHeader>
              <CardBody className="p-6">
                <Nav tabs className="modern-tabs mb-6">
                  <NavItem>
                    <NavLink
                      className={classnames("px-4 py-2 text-gray-700 hover:text-blue-600", { active: activeTab === "motivational" })}
                      onClick={() => toggleTab("motivational")}
                    >
                      متن انگیزشی
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames("px-4 py-2 text-gray-700 hover:text-blue-600", { active: activeTab === "lifestyle" })}
                      onClick={() => toggleTab("lifestyle")}
                    >
                      متن اصلاح سبک زندگی
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames("px-4 py-2 text-gray-700 hover:text-blue-600", { active: activeTab === "video" })}
                      onClick={() => toggleTab("video")}
                    >
                      ویدیو
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="motivational">
                    <Button 
                      color="success" 
                      className="mt-3 px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
                      onClick={() => toggleModal("motivational_text")}
                    >
                      افزودن متن انگیزشی جدید
                    </Button>
                    {loading ? (
                      <p className="text-black">در حال بارگذاری...</p>
                    ) : (
                      <Row className="mt-6">
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">کاهش وزن</h5>
                          {renderTipsTable("motivational_text", "decrease")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">افزایش وزن</h5>
                          {renderTipsTable("motivational_text", "increase")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">ثبات وزن</h5>
                          {renderTipsTable("motivational_text", "stability")}
                        </Col>
                      </Row>
                    )}
                  </TabPane>
                  <TabPane tabId="lifestyle">
                    <Button 
                      color="success" 
                      className="mt-3 px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
                      onClick={() => toggleModal("lifestyle_text")}
                    >
                      افزودن متن اصلاح سبک زندگی جدید
                    </Button>
                    {loading ? (
                      <p className="text-black">در حال بارگذاری...</p>
                    ) : (
                      <Row className="mt-6">
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">کاهش وزن</h5>
                          {renderTipsTable("lifestyle_text", "decrease")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">افزایش وزن</h5>
                          {renderTipsTable("lifestyle_text", "increase")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">ثبات وزن</h5>
                          {renderTipsTable("lifestyle_text", "stability")}
                        </Col>
                      </Row>
                    )}
                  </TabPane>
                  <TabPane tabId="video">
                    <Button 
                      color="success" 
                      className="mt-3 px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
                      onClick={() => toggleModal("video")}
                    >
                      افزودن ویدیو جدید
                    </Button>
                    {loading ? (
                      <p className="text-black">در حال بارگذاری...</p>
                    ) : (
                      <Row className="mt-6">
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">کاهش وزن</h5>
                          {renderTipsTable("video", "decrease")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">افزایش وزن</h5>
                          {renderTipsTable("video", "increase")}
                        </Col>
                        <Col md="4" className="mb-4">
                          <h5 className="text-blue-900 font-semibold mb-3">ثبات وزن</h5>
                          {renderTipsTable("video", "stability")}
                        </Col>
                      </Row>
                    )}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* مودال افزودن/ویرایش نکته */}
        <Modal isOpen={modal} toggle={() => toggleModal()}>
          <ModalHeader toggle={() => toggleModal()} className="bg-blue-900 text-white">
            {editTip ? "ویرایش" : "افزودن"} {currentType === "motivational_text" ? "متن انگیزشی" : currentType === "lifestyle_text" ? "متن اصلاح سبک زندگی" : "ویدیو"}
          </ModalHeader>
          <ModalBody className="bg-gray-50">
            <Form onSubmit={handleSubmit}>
              {currentType !== "video" && (
                <FormGroup>
                  <Label for="text" className="text-blue-900">متن</Label>
                  <ReactQuill
                    value={formData.text}
                    onChange={handleQuillChange}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ['bold', 'italic', 'underline'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['link']
                      ]
                    }}
                    className="bg-white rounded-lg shadow-sm"
                  />
                </FormGroup>
              )}
              {currentType === "video" && (
                <FormGroup>
                  <Label for="video_url" className="text-blue-900">لینک ویدئو</Label>
                  <Input
                    type="text"
                    name="video_url"
                    value={formData.video_url}
                    onChange={handleInputChange}
                    placeholder="https://www.youtube.com/watch?v=... یا https://youtu.be/..."
                    className="form-input rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                  />
                </FormGroup>
              )}
              <FormGroup>
                <Label for="publish_date" className="text-blue-900">تاریخ انتشار</Label>
                <Input
                  type="date"
                  name="publish_date"
                  value={formData.publish_date}
                  onChange={handleInputChange}
                  className="form-input rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                />
              </FormGroup>
              <FormGroup>
                <Label for="expiration_date" className="text-blue-900">تاریخ انقضا</Label>
                <Input
                  type="date"
                  name="expiration_date"
                  value={formData.expiration_date}
                  onChange={handleInputChange}
                  className="form-input rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
                  min={formData.publish_date || new Date().toISOString().split('T')[0]}
                />
              </FormGroup>
              <FormGroup>
  <Label for="diet_type" className="text-blue-900">نوع رژیم (قابلیت انتخاب چندگانه)</Label>
  <Input
    type="select"
    name="diet_type"
    multiple
    value={formData.diet_type}
    onChange={handleDietTypeChange}
    className="form-input rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"
  >
    <option value="decrease">کاهش وزن</option>
    <option value="increase">افزایش وزن</option>
    <option value="stability">ثبات وزن</option>
    <option value="all">همه</option>
  </Input>
            </FormGroup>
              <Button 
                color="primary" 
                type="submit"
                className="px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
              >
                {editTip ? "ذخیره تغییرات" : "افزودن"}
              </Button>
            </Form>
          </ModalBody>
        </Modal>

        {/* مودال پیش‌نمایش ویدئو */}
        <Modal isOpen={previewModal} toggle={() => togglePreviewModal()}>
          <ModalHeader toggle={() => togglePreviewModal()} className="bg-blue-900 text-white">
            پیش‌نمایش ویدئو
          </ModalHeader>
          <ModalBody className="bg-gray-50">
            {previewVideoUrl ? (
              <iframe
                width="100%"
                height="315"
                src={previewVideoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg shadow-sm"
              ></iframe>
            ) : (
              <p className="text-black">لینک ویدئو نامعتبر است یا اجازه جاسازی ندارد.</p>
            )}
          </ModalBody>
          <ModalFooter className="bg-gray-50">
            <Button 
              color="secondary" 
              onClick={() => togglePreviewModal()}
              className="px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
            >
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>

      <style jsx>{`
        .ql-editor {
          min-height: 150px;
          border-radius: 0.5rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }
        .modern-card {
          border-radius: 1rem;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          transition: all 0.3s ease;
        }
        .modern-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
        }
        .modern-tabs {
          border-bottom: 2px solid #e5e7eb;
          margin-bottom: 1.5rem;
        }
        .modern-tabs .nav-link {
          border: none;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          color: #4b5563;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .modern-tabs .nav-link.active {
          border-bottom: 3px solid #2563eb;
          color: #2563eb;
        }
        .modern-table {
          margin-top: 1.5rem;
          border-collapse: separate;
          border-spacing: 0 0.75rem;
        }
        .modern-table th {
          background-color: #f9fafb;
          padding: 1rem;
          font-weight: 600;
          color: #000000;
        }
        .modern-table td {
          background-color: #ffffff;
          padding: 1rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          color: #000000;
        }
        .form-input {
          color: #1f2937 !important;
          background-color: #ffffff !important;
          transition: all 0.2s ease;
        }
        .form-input::placeholder {
          color: #6b7280 !important;
        }
        .form-input[type="date"] {
          padding: 0.75rem;
          border-radius: 0.5rem;
        }
        .modern-table th {
         
          font-weight: 600;
          color: #000000 !important; /* مشکی با اولویت بالا */
        }
        .table > tbody > tr > td{
          
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          color: #000000 !important; /* مشکی با اولویت بالا */
        }
        .table > tbody > tr > td > .text-black > p{
         
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          color: #000000 !important; /* مشکی با اولویت بالا */
        }
      `}</style>
    </>
  );
}

export default MotivationalTips;